import Vue from 'vue'
import { VBtn, VCard, VCardActions, VCardSubtitle, VCardTitle, VDialog, VIcon, VSpacer } from 'vuetify/lib'
import './VDialogDefault.scss'

export const Modal = Vue.component('VDialogDefault', {
	name: 'VDialogDefault',

	props: {
		show: { type: Boolean, default: false },
		title: { type: String, default: '', required: true },
		text: { type: String, default: '', required: false },
		actionButtonText: { type: String, default: 'Prosseguir', required: false },
		cancelButtonText: { type: String, default: 'Cancelar', required: false },
		uniqueCloseButton: { type: String, default: '', required: false },
		icon: { type: String, default: '', required: false },
		content: { type: Object, default: null, required: false },
		isLoading: { type: Boolean, default: false }
	},

	render() {
		return (
			<VDialog v-model={this.show} max-width="600px" persistent content-class="v-dialog-default">
				<VCard class="pa-5 pb-6">
					{this.icon && (
						<VIcon size="34" class="mb-2">
							{this.icon}
						</VIcon>
					)}

					<VCardTitle class="pa-0 pb-2">{this.title}</VCardTitle>

					{this.text && <VCardSubtitle class="mt-0 pa-0" domPropsInnerHTML={this.text}></VCardSubtitle>}

					{this.renderCustomContent()}

					<VCardActions class="pa-0 pt-14">
						<VSpacer />

						{this.uniqueCloseButton && (
							<VBtn loading={this.isLoading} color="primary" depressed onClick={() => this.closeModal()}>
								{this.uniqueCloseButton}
							</VBtn>
						)}

						{!this.uniqueCloseButton && (
							<VBtn loading={this.isLoading} color="primary" outlined onClick={() => this.closeModal()}>
								{this.cancelButtonText}
							</VBtn>
						)}

						{!this.uniqueCloseButton && (
							<VBtn loading={this.isLoading} color="primary" depressed class="px-3" onClick={() => this.confirm()}>
								{this.actionButtonText}
							</VBtn>
						)}
					</VCardActions>
				</VCard>
			</VDialog>
		)
	},

	methods: {
		closeModal() {
			this.$emit('closeModal', true)
		},

		confirm() {
			this.$emit('confirm', true)
		},

		renderCustomContent() {
			if (this.content) return this.content

			return null
		}
	}
})

export default Modal
